/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class TaskState extends JSONable {

  canDelete: boolean | undefined = undefined;
  canCancel: boolean | undefined = undefined;
  canClose: boolean | undefined = undefined;
  canDoFullHandover: boolean | undefined = undefined;
}
